const getters = {
  tags: (state) => state.tags,
  colors: (state) => state.colors,
  forms: (state) => state.forms,
};

export default getters;
